const CART_OVERVIEW_UPDATE_EVENT = 'header:cart:overview:update';

export const updateHeaderCartOverview = () => {
  document.dispatchEvent(new CustomEvent(CART_OVERVIEW_UPDATE_EVENT));
};
